/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rating-bar[_ngcontent-%COMP%]{background-color:#efefef}.rating-bar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff;display:inline-block;font:400 12px/24px museo,serif;height:24px;min-width:15px!important;padding-right:5px;text-align:right;max-width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.rating-bar[_ngcontent-%COMP%]   span.high[_ngcontent-%COMP%]{background-color:#39b57d}.rating-bar[_ngcontent-%COMP%]   span.medium[_ngcontent-%COMP%]{background-color:#ef8246}.rating-bar[_ngcontent-%COMP%]   span.low[_ngcontent-%COMP%]{background-color:#e03200;padding-left:5px}.rating-bar[_ngcontent-%COMP%]   span.zero[_ngcontent-%COMP%]{color:#454f5d;padding-left:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/components/_shared/rating-bar/rating-bar.component.scss.shim.ngstyle.js.pre-build-optimizer.js